import { request } from '@mirai/data-sources';

import { LENGTH_CC_NUMBER } from '../LinkagePay.constants';

export const VomsisService = {
  createPayment: async (accessToken, params) => {
    const { status, data, err_code, message } =
      (await request({
        hostname: process.env.PROVIDER_LINKAGEPAY_API,
        endpoint: '/payment',
        method: 'POST',
        headers: { Authorization: `Bearer ${accessToken}` },
        ...params,
      }).catch(({ code: errorCode, message }) => {
        throw { errorCode, message };
      })) || {};
    if (err_code) throw { errorCode: err_code, message };
    if (status && data) return data;
  },
  getInstallments: async (accessToken, card = '') => {
    if (card.length < LENGTH_CC_NUMBER) return;

    const { data: { installments } = {} } =
      (await request({
        hostname: process.env.PROVIDER_LINKAGEPAY_API,
        endpoint: '/bin-check',
        method: 'POST',
        headers: { Authorization: `Bearer ${accessToken}` },
        cc_number: card.substring(0, LENGTH_CC_NUMBER),
      })) || {};

    return installments;
  },
  notificationError: async (error, url) =>
    request({
      hostname: url,
      method: 'POST',
      ...error,
    }),
};
